module.exports = __webpack_public_path__ + "img/guide1.f09f1a42.png";